import { APP_BAR_STATIC_WIDTH, APP_BAR_WITH_LABELS_STATIC_WIDTH } from 'owa-layout';
import { DEFAULT_FOLDER_PANE_WIDTH } from '../internalConstants';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isWin32StylingEnabled from 'owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled';
import { getLeftNavWidth } from './getLeftNavWidth';

import type { AppBarDisplayModeOptions } from 'owa-outlook-service-option-store';
import { OwsOptionsFeatureType, getOptionsForFeature } from 'owa-outlook-service-option-store';

/**
 * Gets the current padding left of search box.
 * @returns the number of pixels
 */
export default function getSearchBoxLeftPadding(): number {
    const folderPanePadding = 2;
    // The folder pane renders at getLeftNavWidth(), which clamps the stored width to the maximum
    // allowed for the current window size. Using the unclamped stored width leaves the search box
    // to the right of the list view once the window is narrow enough for the clamp to apply.
    const navBarWidth = isWin32StylingEnabled()
        ? getLeftNavWidth()
        : getUserConfiguration().UserOptions?.NavigationBarWidth || DEFAULT_FOLDER_PANE_WIDTH;

    const getAppBarWidth = () => {
        const userOptions = getOptionsForFeature<AppBarDisplayModeOptions>(
            OwsOptionsFeatureType.AppBarDisplayMode
        );
        if (!!userOptions?.labelsEnabled) {
            return APP_BAR_WITH_LABELS_STATIC_WIDTH;
        }

        return APP_BAR_STATIC_WIDTH;
    };

    return folderPanePadding + navBarWidth + getAppBarWidth(); //list view left padding;
}
